<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
              <message :messages="messages"></message>
              <form>
                <v-flex xs12>
                  <v-expansion-panels v-model="panel1" multiple>
                    <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div>
                        <v-icon>mdi-filter-variant</v-icon> Selection Criteria
                      </div>
                    </v-expansion-panel-header>
                      <v-expansion-panel-content>
                      <v-card>
                        <v-card-text>
                          <v-container fluid grid-list-sm>
                            <v-layout row wrap>
                              <v-flex xs6 md6>
                                <cal-picker v-model="form.fromDate" :label="labels.fromDate" v-validate="'required|start_after_today'" :data-vv-as="labels.fromDate" data-vv-name="fromDate" :error-messages="errors.collect('fromDate')"></cal-picker>
                              </v-flex>
                              <v-flex xs6 md6>
                                <cal-picker v-model="form.toDate" :label="labels.toDate" v-validate="toDateValidation(form.fromDate)" :data-vv-as="labels.toDate" data-vv-name="toDate" :error-messages="errors.collect('toDate')" :min="this.form.fromDate"></cal-picker>
                              </v-flex>
                              <v-flex xs6>
                                <v-text-field readonly v-model="form.branch" :label="labels.branch" :error-messages="errors.collect('branch')" data-vv-name="branch" :data-vv-as="labels.branch" v-validate="'required'" append-icon="mdi-magnify" @click:append="getHelpList('branch')"></v-text-field>
                              </v-flex>
                              <v-flex xs6>
                                <v-text-field readonly v-model="form.polType" :label="labels.polType" :error-messages="errors.collect('polType')" data-vv-name="polType" :data-vv-as="labels.polType" v-validate="'required'" append-icon="mdi-magnify" @click:append="getHelpList('polType')"></v-text-field>
                              </v-flex>
                              <v-flex xs6>
                                <v-text-field readonly v-model="form.busCls" :label="labels.busCls" :error-messages="errors.collect('busCls')" data-vv-name="busCls" :data-vv-as="labels.busCls" v-validate="'required'" append-icon="mdi-magnify" @click:append="getHelpList('busCls')"></v-text-field>
                              </v-flex>
                              <v-flex xs6>
                                <v-autocomplete :label="labels.clmStatus" :items="clmStatusList" v-model="form.clmStatus" item-text="value" item-value="code" data-vv-name="clmStatus" :data-vv-as="labels.clmStatus" :error-messages="errors.collect('clmStatus')" v-validate="'required'"></v-autocomplete>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-flex>
                <v-flex xs12>
                  <v-expansion-panels v-model="panel2" multiple>
                    <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div>
                        <v-icon>mdi-filter-variant</v-icon> Sort Order
                      </div>
                    </v-expansion-panel-header>
                      <v-expansion-panel-content>
                      <v-card>
                        <v-card-text>
                          <v-container fluid grid-list-sm>
                            <v-layout row wrap>
                              <v-flex xs4>
                                <v-card-title>
                                  <div class="body-3">Page Header</div>
                                  <v-spacer></v-spacer>
                                  <v-icon @click="getHelpList('pageHeader')">mdi-magnify</v-icon>
                                </v-card-title>
                              </v-flex>
                              <v-flex xs8>
                                <v-data-table
                                :headers="pageHeaderHeader"
                                :items="pageHeader"
                                :no-data-text="noText"
                                hide-default-footer
                                item-key="text"
                                ref="pageHeaderSort"
                                >
                                <template v-slot:item="row">
                                  <tr>
                                    <td width="50px"><v-icon class="phSortIcon">mdi-cursor-move</v-icon></td>
                                    <td>{{ row.item.text }}</td>
                                    <td>{{ row.item.subTotal ? 'Yes' : 'No' }}</td>
                                    <td>{{ row.item.pageBreak ? 'Yes' : 'No' }}</td>
                                  </tr>
                                </template>
                                </v-data-table>
                                <p v-if="pageHeader.length > 1" align="center">Hold the icon to arrange the sequence</p>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs4>
                                <v-card-title>
                                  <div class="body-3">Detail Line</div>
                                  <v-spacer></v-spacer>
                                  <v-icon @click="getHelpList('detailLine')">mdi-magnify</v-icon>
                                </v-card-title>
                              </v-flex>
                              <v-flex xs8>
                                <v-data-table
                                :headers="detailLineHeader"
                                :items="detailLine"
                                :no-data-text="noText"
                                hide-default-footer
                                item-key="text"
                                ref="detailLineSort"
                                >
                                <template v-slot:item="row">
                                  <tr>
                                    <td width="50px"><v-icon class="dlSortIcon">mdi-cursor-move</v-icon></td>
                                    <td>{{ row.item.text }}</td>
                                    <td>{{ row.item.subTotal ? 'Yes' : 'No' }}</td>
                                    <td>{{ row.item.pageBreak ? 'Yes' : 'No' }}</td>
                                  </tr>
                                </template>
                                </v-data-table>
                                <p v-if="detailLine.length > 1" align="center">Hold the icon to arrange the sequence</p>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-flex>
                 <v-flex xs12>
                  <v-expansion-panels v-model="panel3" multiple>
                    <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div>
                        <v-icon>mdi-filter-variant</v-icon> Report Setting
                      </div>
                    </v-expansion-panel-header>
                      <v-expansion-panel-content>
                      <v-card>
                        <v-card-text>
                          <v-container fluid grid-list-sm>
                            <v-layout row wrap>
                              <v-flex xs6>
                                <v-autocomplete :label="labels.rptType" :items="rptTypeList" v-model="form.rptType" item-text="value" item-value="code" data-vv-name="rptType" :data-vv-as="labels.rptType" v-validate="'required'" :error-messages="errors.collect('rptType')"></v-autocomplete>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-flex>
                <v-flex xs12 class="pt-3">
                  <v-checkbox v-model="form.printRTParam" :label="labels.printRTParam" :error-messages="errors.collect('printRTParam')" data-vv-name="printRTParam" :data-vv-as="labels.printRTParam" v-validate="'required'"></v-checkbox>
                  <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                    <v-icon left dark>mdi-file-export</v-icon>
                    {{labels.export}}
                  </v-btn>
                  <v-btn-toggle dense mandatory v-model="form.format">
                    <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                      <span>{{format.label}}</span>
                      <v-icon :color="format.color">{{format.icon}}</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </v-flex>
              </form>
            <!-- </v-card-text>
          </v-card> -->
        </v-flex>
        <v-dialog v-model="branchList" width="900px" persistent>
          <branch-help-list v-if="doneInitialization" v-show="branchHelpList" :menu="menu" @close="doClose" @doAssign="doAssign($event)"></branch-help-list>
        </v-dialog>
        <v-dialog v-model="polTypeList" width="900px" persistent>
          <polType-help-list v-if="doneInitialization" v-show="polTypeHelpList" :menu="menu" @close="doClose" @doAssign="doAssign($event)"></polType-help-list>
        </v-dialog>
        <v-dialog v-model="busClsList" width="900px" persistent>
          <bus-cls-help-list v-if="doneInitialization" v-show="busClsHelpList" :menu="menu" @close="doClose" @doAssign="doAssign($event)"></bus-cls-help-list>
        </v-dialog>
        <v-dialog v-model="pageHeaderList" width="900px" persistent>
          <page-header-help-list v-if="pageHeaderHelpList" :pgheader="pageHeader" @close="doClose" @doAssign="doAssign($event)"></page-header-help-list>
        </v-dialog>
        <v-dialog v-model="detailLineList" width="900px" persistent>
          <detail-line-help-list v-if="detailLineHelpList" :dl="detailLine" @close="doClose" @doAssign="doAssign($event)"></detail-line-help-list>
        </v-dialog>
      </v-layout>
    </v-container>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import BranchHelpList from './BranchHelpList.vue'
import PolTypeHelpList from './PolTypeHelpList.vue'
import BusClsHelpList from './BusClsHelpList.vue'
import PageHeaderHelpList from './PageHeaderHelpList.vue'
import DetailLineHelpList from './DetailLineHelpList.vue'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'
import clone from 'clone'
import Sortable from 'sortablejs'
export default {
  data() {
    return {
      labels: {
        fromDate: 'Date From*',
        toDate: 'Date To*',
        branch: 'Branch',
        polType: 'Policy Type',
        busCls: 'Business Class',
        clmStatus: 'Claim Status',
        sortOrder: 'Sort Order',
        pageBreak: 'Page Break',
        rptType: 'Report Type',
        printRTParam: 'Print Runtime Parameters',
        subTotal: 'Sub Total',
        export: 'EXPORT TO',
        sendEmail: 'Send Output to Email'
      },
      form: {
        fromDate: '',
        toDate: '',
        branch: 'All',
        polType: 'All',
        busCls: 'All',
        clmStatus: '',
        rptType: '',
        printRTParam: true,
        subTotal: '',
        format: 'PDF',
        sendEmail: false
      },
      clmStatusList: [
        { code: '1', value: 'Outstanding Claims' },
        { code: '2', value: 'New Claims' },
        { code: '3', value: 'Reopened Claims' },
        { code: '4', value: 'Payments / Receipts and Recoveries' }
      ],
      rptTypeList: [
        { code: 'D', value: 'Detail' },
        { code: 'S', value: 'Summary' },
        { code: 'B', value: 'Both' }
      ],
      menu: {},
      supportedFormat: [],
      submitting: false,
      branchList: false,
      branchHelpList: false,
      polTypeList: false,
      polTypeHelpList: false,
      busClsList: false,
      busClsHelpList: false,
      pageHeaderHeader: [
        { text: '', value: 'pgIcon', sortable: false },
        { text: 'Sort Order', value: 'text', sortable: false },
        { text: 'Sub Total', value: 'subTotal', sortable: false },
        { text: 'Page Break', value: 'pageBreak', sortable: false }
      ],
      pageHeader: [],
      detailLineHeader: [
        { text: '', value: 'dlIcon', sortable: false },
        { text: 'Sort Order', value: 'sortOrder', sortable: false },
        { text: 'Sub Total', value: 'subTotal', sortable: false },
        { text: 'Page Break', value: 'pageBreak', sortable: false }
      ],
      detailLine: [],
      pageHeaderList: false,
      pageHeaderHelpList: false,
      detailLineList: false,
      detailLineHelpList: false,
      noText: 'Sort Order is Not Selected!',
      phNewSortIndex: [],
      doneInitialization: false,
      panel1: [0],
      panel2: [0],
      panel3: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.claimReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    phNewSortHtml() {
      if (this.pageHeader.length === 0) {
        return ''
      } else {
        return this.$refs['pageHeaderSort'].$el.firstElementChild.firstElementChild.tBodies[0].rows
      }
    },
    dlNewSortHtml() {
      if (this.detailLine.length === 0) {
        return ''
      } else {
        return this.$refs['detailLineSort'].$el.firstElementChild.firstElementChild.tBodies[0].rows
      }
    }
  },
  watch: {
    'supportedList': function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.form.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.claimReports.init !== 1) {
          await this.$store.dispatch('claimReportsInit')
        }
        const apiURI = this.rptMenu.claimRegister
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result
          if (data) {
            this.supportedFormat = data.data.format
            this.menu = extractMenu(result.data._links)
          }
        }
        this.doneInitialization = true
      } catch (err) {
        throw err
      }
    },
    toDateValidation(fromDate) {
      const result = 'required|from_to_date:' + fromDate
      return result
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          let cDetail1 = ''
          let cDetail2 = ''
          let cDetail3 = ''
          let bDetPgBrk1 = false
          let bDetPgBrk2 = false
          let bDetPgBrk3 = false
          let bDetSubTot1 = false
          let bDetSubTot2 = false
          let bDetSubTot3 = false
          let cHdr1 = ''
          let cHdr2 = ''
          let cHdr3 = ''
          let bHdrPgBrk1 = false
          let bHdrPgBrk2 = false
          let bHdrPgBrk3 = false
          let bHdrSubTot1 = false
          let bHdrSubTot2 = false
          let bHdrSubTot3 = false
          // Note: Directly get page header / detail line sorting from the innerHTML
          // Instead of the array of pageHeader/detailLine
          // Due to the plugin's function not supporting in accessing/returning data from the main page
          // Also the vue.watch are not able to observe HTML element that changes
          // Therefore I can only made it changes on the process where it sends to the API
          // Based on the HTML element
          // by CBO on 3rd Feb 2020
          let ph = this.phNewSortHtml
          for (var iPh = 0; iPh < ph.length; iPh++) {
            if (cHdr1 === '') {
              cHdr1 = ph[iPh].children[1].innerHTML
              bHdrSubTot1 = (ph[iPh].children[2].innerHTML === 'Yes' ? Boolean(true) : Boolean(false))
              bHdrPgBrk1 = (ph[iPh].children[3].innerHTML === 'Yes' ? Boolean(true) : Boolean(false))
            } else if (cHdr2 === '') {
              cHdr2 = ph[iPh].children[1].innerHTML
              bHdrSubTot2 = (ph[iPh].children[2].innerHTML === 'Yes' ? Boolean(true) : Boolean(false))
              bHdrPgBrk2 = (ph[iPh].children[3].innerHTML === 'Yes' ? Boolean(true) : Boolean(false))
            } else if (cHdr3 === '') {
              cHdr3 = ph[iPh].children[1].innerHTML
              bHdrSubTot3 = (ph[iPh].children[2].innerHTML === 'Yes' ? Boolean(true) : Boolean(false))
              bHdrPgBrk3 = (ph[iPh].children[3].innerHTML === 'Yes' ? Boolean(true) : Boolean(false))
            }
          }
          let dl = this.dlNewSortHtml
          for (var iDl = 0; iDl < dl.length; iDl++) {
            if (cDetail1 === '') {
              cDetail1 = dl[iDl].children[1].innerHTML
              bDetSubTot1 = (dl[iDl].children[2].innerHTML === 'Yes' ? Boolean(true) : Boolean(false))
              bDetPgBrk1 = (dl[iDl].children[3].innerHTML === 'Yes' ? Boolean(true) : Boolean(false))
            } else if (cDetail2 === '') {
              cDetail2 = dl[iDl].children[1].innerHTML
              bDetSubTot2 = (dl[iDl].children[2].innerHTML === 'Yes' ? Boolean(true) : Boolean(false))
              bDetPgBrk2 = (dl[iDl].children[3].innerHTML === 'Yes' ? Boolean(true) : Boolean(false))
            } else if (cDetail3 === '') {
              cDetail3 = dl[iDl].children[1].innerHTML
              bDetSubTot3 = (dl[iDl].children[2].innerHTML === 'Yes' ? Boolean(true) : Boolean(false))
              bDetPgBrk3 = (dl[iDl].children[3].innerHTML === 'Yes' ? Boolean(true) : Boolean(false))
            }
          }
          let tempForm = clone(this.form)
          const sendForm = {
            cDetail1: cDetail1,
            cDetail2: cDetail2,
            cDetail3: cDetail3,
            bDetPgBrk1: bDetPgBrk1,
            bDetPgBrk2: bDetPgBrk2,
            bDetPgBrk3: bDetPgBrk3,
            bDetSubTot1: bDetSubTot1,
            bDetSubTot2: bDetSubTot2,
            bDetSubTot3: bDetSubTot3,
            cHdr1: cHdr1,
            cHdr2: cHdr2,
            cHdr3: cHdr3,
            bHdrPgBrk1: bHdrPgBrk1,
            bHdrPgBrk2: bHdrPgBrk2,
            bHdrPgBrk3: bHdrPgBrk3,
            bHdrSubTot1: bHdrSubTot1,
            bHdrSubTot2: bHdrSubTot2,
            bHdrSubTot3: bHdrSubTot3,
            bPrtParam: tempForm.printRTParam,
            cBranchList: tempForm.branch,
            cBusClsList: tempForm.busCls,
            cClmStatus: tempForm.clmStatus,
            cExp: tempForm.format,
            cPolTypeList: tempForm.polType,
            cRptType: tempForm.rptType,
            dTranDateFrom: tempForm.fromDate,
            dTranDateTo: tempForm.toDate,
            format: tempForm.format
          }
          await this.$http.post(apiURI, sendForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    getHelpList(fieldName) {
      switch (fieldName) {
        case 'branch':
          this.branchList = true
          this.branchHelpList = true
          break
        case 'polType':
          this.polTypeList = true
          this.polTypeHelpList = true
          break
        case 'busCls':
          this.busClsList = true
          this.busClsHelpList = true
          break
        case 'pageHeader':
          this.pageHeaderList = true
          this.pageHeaderHelpList = true
          break
        case 'detailLine':
          this.detailLineList = true
          this.detailLineHelpList = true
          break
        default:
          this.$toast.error('Field Name Not Found!')
      }
    },
    doClose() {
      this.branchList = false
      this.branchHelpList = false
      this.polTypeList = false
      this.polTypeHelpList = false
      this.busClsList = false
      this.busClsHelpList = false
      this.pageHeaderList = false
      this.pageHeaderHelpList = false
      this.detailLineList = false
      this.detailLineHelpList = false
    },
    async doAssign(Obj) {
      if (Obj.finalSelectedItems) {
        if (this.branchHelpList) {
          this.form.branch = []
          this.form.branch = Obj.finalSelectedItems.toString()
        } else if (this.polTypeHelpList) {
          this.form.polType = []
          this.form.polType = Obj.finalSelectedItems.toString()
        } else if (this.busClsHelpList) {
          this.form.busCls = []
          this.form.busCls = Obj.finalSelectedItems.toString()
        }
      } else if (Obj.from) {
        let from = Obj.from
        switch (from) {
          case 'branch':
            this.form.branch = []
            this.form.branch = Obj.finalSelectedItems.toString()
            break
          case 'polType':
            this.form.polType = []
            this.form.polType = Obj.finalSelectedItems.toString()
            break
          case 'busCls':
            this.form.busCls = []
            this.form.busCls = Obj.finalSelectedItems.toString()
            break
          case 'pageHeader':
            this.pageHeader = []
            this.pageHeader = Obj.pageHeader
            // Added on 3rd Feb 2020
            // Accessing v-data-table's exact html code of tablebodies in VueElement Ref
            var pageHeaderSortHtml = this.$refs['pageHeaderSort'].$el.firstElementChild.firstElementChild.tBodies[0]
            Sortable.create(pageHeaderSortHtml, {
              group: 'pageHeaderSort', // group of data
              sort: true, // default allow to sort the table lst
              swapThreshold: 0.65, // the threshold position to swap the element
              delay: 1000, // time in milliseconds to define when the sorting should start
              delayOnTouchOnly: true, // only delay if user is using touch
              handle: '.phSortIcon', // to make this class to handle the sort
              animation: 150 // animation
            })
            break
          case 'detailLine':
            this.detailLine = []
            this.detailLine = Obj.detailLine
            // Added on 3rd Feb 2020
            var detailLineSortHtml = this.$refs['detailLineSort'].$el.firstElementChild.firstElementChild.tBodies[0]
            Sortable.create(detailLineSortHtml, {
              group: 'detailLineSort',
              sort: true,
              swapThreshold: 0.65,
              delay: 1000,
              delayOnTouchOnly: true,
              handle: '.dlSortIcon',
              animation: 150
            })
            break
          default:
            this.$toast.error('No Assignment Returned!')
        }
      } else {
        this.$toast.error('Help List Assignment Missing')
      }
    }
  },
  created() {
    this.doInit()
    this.$validator.extend('start_after_today', {
      getMessage(field, args) {
        return `The ${field} cannot be later than the date of application.`
      },
      validate(value, args) {
        if (value) {
          const today = removeTime(new Date())
          const tomorrow = new Date(today)
          tomorrow.setDate(tomorrow.getDate() + 1)
          const startDate = removeTime(value)
          // if (isAfter(today, startDate)) return false
          // else return true
          return (isAfter(tomorrow, startDate))
        } else return true
      }
    })
  },
  mounted() {

  },
  mixins: [
    MessageMixin
  ],
  components: {
    BranchHelpList,
    PolTypeHelpList,
    BusClsHelpList,
    PageHeaderHelpList,
    DetailLineHelpList
  }
}
</script>
